import React, { Component } from 'react';
import "../css/CAlert.css";
interface AlertProps {
    message: string;
    heading: string;
    type: string;
    closecallback: () => void;
}

class CAlert extends Component<AlertProps, {}> {
    render() {
        return (
            <div>
                <div className="alertdiv">
                    <div className={`alert ${this.props.type === "warning" ? " alert-warning " : (this.props.type === "success" ? " alert-success " : " alert-danger ")}alert-dismissible fade show`} role="alert">
                        <h6 className="alert-heading"><strong>{this.props.heading}</strong>
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={this.props.closecallback}>
                                <span aria-hidden="true">&times;</span>
                            </button></h6>
                        <div dangerouslySetInnerHTML={{ __html: this.props.message }}></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CAlert;
